export function isInstagram(link: string) {
    return link.indexOf('instagram') >= 0 || link.indexOf('instagr.am') >= 0
}

export function parseInstagramLink(link: string) {
    try {
        const regexp = /^(?:.*\/(p|tv|reel)\/)([\d\w\-_]+)/
        const regexu = /^(?:.*\/guide\/[\w\-_]+)([a-z]+.)([\d_]*)/
        const match = regexp.exec(link) || regexu.exec(link)
        return { url: match && match[0], shortCode: match && match[2] }
    } catch (e) {
        return { url: null, shortCode: null }
    }
}

export declare const instgrm: { Embeds: { process: () => void } }

// Init func to ensure instagram.Embeds.process init is called once on multiple instagram embeds on one page
let initFunc: NodeJS.Timeout | null = null

export function initInsta() {
    if (initFunc) {
        clearTimeout(initFunc)
        initFunc = null
    }

    initFunc = setTimeout(() => {
        instgrm.Embeds.process()
    }, 200)
}
